import _regeneratorRuntime from 'babel-runtime/regenerator';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Promise from 'bluebird';
import * as d3 from 'd3';
import isEqual from 'lodash.isequal';
import DataContext from '../../context/Data';
import GriffPropTypes, { seriesPropType } from '../../utils/proptypes';
import Scaler, { PLACEHOLDER_DOMAIN } from '../Scaler';

export var calculateDomainFromData = function calculateDomainFromData(data, accessor) {
  var minAccessor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var maxAccessor = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  // if there is no data, hard code the domain
  if (!data || !data.length) {
    return [-0.25, 0.25];
  }

  var extent = void 0;
  if (minAccessor && maxAccessor) {
    extent = [d3.min(data, minAccessor), d3.max(data, maxAccessor)];
  } else {
    extent = d3.extent(data, accessor);
  }
  var diff = extent[1] - extent[0];
  if (Math.abs(diff) < 1e-3) {
    if (extent[0] === 0) {
      // If 0 is the only value present in the series, hard code domain.
      return [-0.25, 0.25];
    }
    var domain = [1 / 2 * extent[0], 3 / 2 * extent[0]];
    if (domain[1] < domain[0]) {
      return [domain[1], domain[0]];
    }
    return domain;
  }
  return [extent[0] - diff * 0.025, extent[1] + diff * 0.025];
};

var deleteUndefinedFromObject = function deleteUndefinedFromObject(obj) {
  if (!obj) {
    return {};
  }
  var newObject = {};
  Object.keys(obj).forEach(function (k) {
    if (obj[k] !== undefined) {
      newObject[k] = obj[k];
    }
  });
  return newObject;
};

/**
 * Return the first thing which is not `undefined`.
 * @param {*} first
 * @param  {...any} others
 */
var firstDefined = function firstDefined(first) {
  for (var _len = arguments.length, others = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    others[_key - 1] = arguments[_key];
  }

  if (first !== undefined || others.length === 0) {
    return first;
  }
  return firstDefined.apply(undefined, [others[0]].concat(others.splice(1)));
};

var DataProvider = (_temp2 = _class = function (_Component) {
  _inherits(DataProvider, _Component);

  function DataProvider() {
    var _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, DataProvider);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      timeSubDomain: DataProvider.getTimeSubDomain(_this.props.timeDomain, _this.props.timeSubDomain, _this.props.limitTimeSubDomain),
      timeDomain: _this.props.timeDomain,
      loaderConfig: {},
      timeDomains: {},
      timeSubDomains: {},
      xDomains: {},
      xSubDomains: {},
      yDomains: {},
      ySubDomains: {}
    }, _this.getSeriesObjects = function () {
      var collectionsById = {};
      (_this.props.collections || []).forEach(function (c) {
        collectionsById[c.id] = c;
      });
      return _this.props.series.map(function (s) {
        return _this.enrichSeries(s, collectionsById[s.collectionId || ''] || {});
      });
    }, _this.getSingleSeriesObject = function (id) {
      var series = _this.props.series.find(function (s) {
        return id === s.id;
      });
      if (!series) {
        throw new Error('Trying to get single series object for id ' + id + ' which is not defined in props.');
      }
      return _this.enrichSeries(series, series.collectionId ? (_this.props.collections || []).find(function (c) {
        return series.collectionId === c.id;
      }) : {});
    }, _this.startUpdateInterval = function () {
      var updateInterval = _this.props.updateInterval;

      if (updateInterval) {
        clearInterval(_this.fetchInterval);
        _this.fetchInterval = setInterval(function () {
          var _this$state = _this.state,
              timeDomain = _this$state.timeDomain,
              timeSubDomain = _this$state.timeSubDomain;

          var newTimeDomain = timeDomain.map(function (d) {
            return d + updateInterval;
          });
          var newTimeSubDomain = _this.props.isTimeSubDomainSticky ? DataProvider.getTimeSubDomain(newTimeDomain, timeSubDomain.map(function (d) {
            return d + updateInterval;
          }), _this.props.limitTimeSubDomain) : timeSubDomain;
          _this.setState({
            timeDomain: newTimeDomain,
            timeSubDomain: newTimeSubDomain
          }, function () {
            _this.props.series.map(function (s) {
              return _this.fetchData(s.id, 'INTERVAL');
            });
          });
        }, updateInterval);
      }
    }, _this.enrichSeries = function (series) {
      var collection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _this$props = _this.props,
          drawPoints = _this$props.drawPoints,
          drawLines = _this$props.drawLines,
          opacity = _this$props.opacity,
          opacityAccessor = _this$props.opacityAccessor,
          pointWidth = _this$props.pointWidth,
          pointWidthAccessor = _this$props.pointWidthAccessor,
          strokeWidth = _this$props.strokeWidth,
          timeAccessor = _this$props.timeAccessor,
          propTimeDomain = _this$props.timeDomain,
          timeSubDomain = _this$props.timeSubDomain,
          xAccessor = _this$props.xAccessor,
          x0Accessor = _this$props.x0Accessor,
          x1Accessor = _this$props.x1Accessor,
          propXDomain = _this$props.xDomain,
          propXSubDomain = _this$props.xSubDomain,
          y0Accessor = _this$props.y0Accessor,
          y1Accessor = _this$props.y1Accessor,
          yAccessor = _this$props.yAccessor,
          propYDomain = _this$props.yDomain,
          propYSubDomain = _this$props.ySubDomain;
      var _this$state2 = _this.state,
          loaderConfig = _this$state2.loaderConfig,
          timeDomains = _this$state2.timeDomains,
          timeSubDomains = _this$state2.timeSubDomains,
          xDomains = _this$state2.xDomains,
          xSubDomains = _this$state2.xSubDomains,
          yDomains = _this$state2.yDomains,
          ySubDomains = _this$state2.ySubDomains;

      var yDomain = collection.yDomain || series.yDomain || propYDomain || yDomains[series.id] || PLACEHOLDER_DOMAIN;
      var xDomain = collection.xDomain || series.xDomain || propXDomain || xDomains[series.id] || PLACEHOLDER_DOMAIN;
      var timeDomain = collection.timeDomain || series.timeDomain || timeDomains[series.id] || propTimeDomain || PLACEHOLDER_DOMAIN;
      return _extends({
        hidden: collection.hidden,
        data: []
      }, deleteUndefinedFromObject(loaderConfig[series.id]), deleteUndefinedFromObject(series), {
        drawPoints: firstDefined((loaderConfig[series.id] || {}).drawPoints, series.drawPoints, collection.drawPoints, drawPoints),
        drawLines: firstDefined((loaderConfig[series.id] || {}).drawLines, series.drawLines, collection.drawLines, drawLines),
        timeAccessor: firstDefined(series.timeAccessor, collection.timeAccessor, timeAccessor),
        xAccessor: firstDefined(series.xAccessor, collection.xAccessor, xAccessor),
        x0Accessor: firstDefined(series.x0Accessor, collection.x0Accessor, x0Accessor),
        x1Accessor: firstDefined(series.x1Accessor, collection.x1Accessor, x1Accessor),
        yAccessor: firstDefined(series.yAccessor, collection.yAccessor, yAccessor),
        y0Accessor: firstDefined(series.y0Accessor, collection.y0Accessor, y0Accessor),
        y1Accessor: firstDefined(series.y1Accessor, collection.y1Accessor, y1Accessor),
        strokeWidth: firstDefined(series.strokeWidth, collection.strokeWidth, strokeWidth),
        pointWidth: firstDefined(series.pointWidth, collection.pointWidth, pointWidth),
        pointWidthAccessor: firstDefined(series.pointWidthAccessor, collection.pointWidthAccessor, pointWidthAccessor),
        opacity: firstDefined(series.opacity, collection.opacity, opacity),
        opacityAccessor: firstDefined(series.opacityAccessor, collection.opacityAccessor, opacityAccessor),
        yAxisDisplayMode: (series.collectionId ? collection.yAxisDisplayMode : series.yAxisDisplayMode) || collection.yAxisDisplayMode,
        timeDomain: timeDomain,
        timeSubDomain: collection.timeSubDomain || series.timeSubDomain || timeSubDomains[series.id] || timeSubDomain || timeDomain,
        xDomain: xDomain,
        xSubDomain: collection.xSubDomain || series.xSubDomain || propXSubDomain || xSubDomains[series.id] || xDomain,
        yDomain: yDomain,
        ySubDomain: collection.ySubDomain || series.ySubDomain || propYSubDomain || ySubDomains[series.id] || yDomain
      });
    }, _this.fetchData = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id, reason) {
        var _extends6;

        var _this$props2, pointsPerSeries, defaultLoader, _this$state3, timeSubDomain, timeDomain, seriesObject, loader, loaderResult, loaderConfig, stateUpdates, _extends2, _extends3, _extends4, _extends5, calculatedTimeDomain, calculatedTimeSubDomain, xSubDomain, ySubDomain;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props2 = _this.props, pointsPerSeries = _this$props2.pointsPerSeries, defaultLoader = _this$props2.defaultLoader;
                _this$state3 = _this.state, timeSubDomain = _this$state3.timeSubDomain, timeDomain = _this$state3.timeDomain;
                seriesObject = _this.getSingleSeriesObject(id);
                loader = seriesObject.loader || defaultLoader;

                if (loader) {
                  _context.next = 6;
                  break;
                }

                throw new Error('Series ' + id + ' does not have a loader.');

              case 6:
                _context.next = 8;
                return loader({
                  id: id,
                  timeDomain: timeDomain,
                  timeSubDomain: timeSubDomain,
                  pointsPerSeries: pointsPerSeries,
                  oldSeries: seriesObject,
                  reason: reason
                });

              case 8:
                loaderResult = _context.sent;
                loaderConfig = _extends({
                  data: [],
                  id: id
                }, loaderResult, {
                  reason: reason,
                  yAccessor: seriesObject.yAccessor,
                  y0Accessor: seriesObject.y0Accessor,
                  y1Accessor: seriesObject.y1Accessor
                });
                stateUpdates = {};

                if (reason === 'MOUNTED' || seriesObject.data.length === 0 && loaderConfig.data.length > 0) {
                  calculatedTimeDomain = calculateDomainFromData(loaderConfig.data, loaderConfig.timeAccessor || _this.props.timeAccessor);
                  calculatedTimeSubDomain = calculatedTimeDomain;

                  stateUpdates.timeDomains = _extends({}, _this.state.timeDomains, (_extends2 = {}, _extends2[id] = calculatedTimeDomain, _extends2));
                  stateUpdates.timeSubDomains = _extends({}, _this.state.timeSubDomains, (_extends3 = {}, _extends3[id] = calculatedTimeSubDomain, _extends3));

                  xSubDomain = calculateDomainFromData(loaderConfig.data, loaderConfig.xAccessor || _this.props.xAccessor, loaderConfig.x0Accessor || _this.props.x0Accessor, loaderConfig.x1Accessor || _this.props.x1Accessor);

                  stateUpdates.xSubDomains = _extends({}, _this.state.xSubDomains, (_extends4 = {}, _extends4[id] = xSubDomain, _extends4));

                  ySubDomain = calculateDomainFromData(loaderConfig.data, loaderConfig.yAccessor || _this.props.yAccessor, loaderConfig.y0Accessor || _this.props.y0Accessor, loaderConfig.y1Accessor || _this.props.y1Accessor);

                  stateUpdates.ySubDomains = _extends({}, _this.state.ySubDomains, (_extends5 = {}, _extends5[id] = ySubDomain, _extends5));
                }
                stateUpdates.loaderConfig = _extends({}, _this.state.loaderConfig, (_extends6 = {}, _extends6[id] = _extends({}, loaderConfig), _extends6));
                _this.setState(stateUpdates, function () {
                  _this.props.onFetchData(_extends({}, loaderConfig));
                });

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x4, _x5) {
        return _ref.apply(this, arguments);
      };
    }(), _this.timeSubDomainChanged = function (timeSubDomain) {
      var current = _this.state.timeSubDomain;
      var newTimeSubDomain = DataProvider.getTimeSubDomain(_this.state.timeDomain, timeSubDomain, _this.props.limitTimeSubDomain);
      if (isEqual(newTimeSubDomain, current)) {
        return;
      }

      clearTimeout(_this.timeSubDomainChangedTimeout);
      _this.timeSubDomainChangedTimeout = setTimeout(function () {
        return _this.props.series.map(function (s) {
          return _this.fetchData(s.id, 'UPDATE_SUBDOMAIN');
        });
      }, 250);
      _this.setState({ timeSubDomain: newTimeSubDomain }, function () {
        if (_this.props.onTimeSubDomainChanged) {
          _this.props.onTimeSubDomainChanged(newTimeSubDomain);
        }
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  DataProvider.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    // Check if one of the series got removed from props
    // If so, delete the respective keys in loaderconfig
    // This is important so we don't cache the values if it gets readded later
    var loaderConfig = prevState.loaderConfig,
        yDomains = prevState.yDomains,
        ySubDomains = prevState.ySubDomains;
    var series = nextProps.series;

    var seriesKeys = {};
    series.forEach(function (s) {
      seriesKeys[s.id] = true;
    });
    var newLoaderConfig = _extends({}, loaderConfig);
    var newYDomains = _extends({}, yDomains);
    var newYSubDomains = _extends({}, ySubDomains);
    var shouldUpdate = false;
    Object.keys(loaderConfig).forEach(function (key) {
      if (!seriesKeys[key]) {
        // Clean up
        delete newLoaderConfig[key];
        delete newYDomains[key];
        shouldUpdate = true;
      }
    });
    if (shouldUpdate) {
      return {
        loaderConfig: newLoaderConfig,
        yDomains: newYDomains,
        ySubDomains: newYSubDomains
      };
    }
    return null;
  };

  DataProvider.prototype.componentDidMount = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this3 = this;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              this.startUpdateInterval();
              _context2.next = 3;
              return Promise.map(this.props.series, function (s) {
                return _this3.fetchData(s.id, 'MOUNTED');
              });

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function componentDidMount() {
      return _ref2.apply(this, arguments);
    }

    return componentDidMount;
  }();

  DataProvider.prototype.componentDidUpdate = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(prevProps) {
      var _this4 = this;

      var updateInterval, prevUpdateInterval, prevSeries, series, _state, timeSubDomain, timeDomain, currentSeriesKeys, prevSeriesKeys, newSeries, newTimeSubDomain;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              // If new series are present in prop,
              // run the fetchData lifecycle for those series
              updateInterval = this.props.updateInterval;
              prevUpdateInterval = prevProps.updateInterval;

              if (updateInterval !== prevUpdateInterval) {
                if (prevUpdateInterval) {
                  clearInterval(this.fetchInterval);
                }
                if (updateInterval) {
                  this.startUpdateInterval();
                }
              }

              // check if pointsPerSeries changed in props -- if so fetch new data

              if (!(this.props.pointsPerSeries !== prevProps.pointsPerSeries)) {
                _context4.next = 6;
                break;
              }

              _context4.next = 6;
              return Promise.map(this.props.series, function (s) {
                return _this4.fetchData(s.id, 'UPDATE_POINTS_PER_SERIES');
              });

            case 6:
              prevSeries = prevProps.series;

              if (prevSeries) {
                _context4.next = 9;
                break;
              }

              return _context4.abrupt('return');

            case 9:
              series = this.props.series;
              _state = this.state, timeSubDomain = _state.timeSubDomain, timeDomain = _state.timeDomain;


              if (!isEqual(this.props.timeSubDomain, prevProps.timeSubDomain)) {
                this.timeSubDomainChanged(this.props.timeSubDomain);
              }

              currentSeriesKeys = {};

              series.forEach(function (s) {
                currentSeriesKeys[s.id] = true;
              });
              prevSeriesKeys = {};

              prevSeries.forEach(function (p) {
                prevSeriesKeys[p.id] = true;
              });
              newSeries = series.filter(function (s) {
                return prevSeriesKeys[s.id] !== true;
              });
              _context4.next = 19;
              return Promise.map(newSeries, function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5) {
                  var id = _ref5.id;
                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 2;
                          return _this4.fetchData(id, 'MOUNTED');

                        case 2:
                          if (isEqual(timeSubDomain, timeDomain)) {
                            _context3.next = 5;
                            break;
                          }

                          _context3.next = 5;
                          return _this4.fetchData(id, 'UPDATE_SUBDOMAIN');

                        case 5:
                        case 'end':
                          return _context3.stop();
                      }
                    }
                  }, _callee3, _this4);
                }));

                return function (_x7) {
                  return _ref4.apply(this, arguments);
                };
              }());

            case 19:

              // Check if timeDomain changed in props -- if so reset state.
              if (!isEqual(this.props.timeDomain, prevProps.timeDomain)) {
                newTimeSubDomain = DataProvider.getTimeSubDomain(this.props.timeDomain, this.props.timeSubDomain, this.props.limitTimeSubDomain);
                // eslint-disable-next-line

                this.setState({
                  timeDomain: this.props.timeDomain,
                  timeSubDomain: newTimeSubDomain,
                  loaderConfig: {},
                  yDomains: {},
                  ySubDomains: {}
                }, function () {
                  _this4.props.series.map(function (s) {
                    return _this4.fetchData(s.id, 'MOUNTED');
                  });
                  if (_this4.props.onTimeSubDomainChanged) {
                    _this4.props.onTimeSubDomainChanged(newTimeSubDomain);
                  }
                });
                this.startUpdateInterval();
              }

            case 20:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function componentDidUpdate(_x6) {
      return _ref3.apply(this, arguments);
    }

    return componentDidUpdate;
  }();

  DataProvider.prototype.componentWillUnmount = function componentWillUnmount() {
    clearInterval(this.fetchInterval);
  };

  DataProvider.prototype.render = function render() {
    var _state2 = this.state,
        loaderConfig = _state2.loaderConfig,
        timeDomain = _state2.timeDomain,
        timeSubDomain = _state2.timeSubDomain;
    var _props = this.props,
        yAxisWidth = _props.yAxisWidth,
        children = _props.children,
        externalTimeDomain = _props.timeDomain,
        externalTimeSubDomain = _props.timeSubDomain,
        collections = _props.collections,
        onUpdateDomains = _props.onUpdateDomains;


    if (Object.keys(loaderConfig).length === 0) {
      // Do not bother, loader hasn't given any data yet.
      return null;
    }
    var seriesObjects = this.getSeriesObjects();

    // Compute the domains for all of the collections with one pass over all of
    // the series objects.
    var collectionDomains = seriesObjects.reduce(function (acc, _ref6) {
      var _extends7;

      var collectionId = _ref6.collectionId,
          seriesDomain = _ref6.yDomain,
          seriesXSubDomain = _ref6.ySubDomain;

      if (!collectionId) {
        return acc;
      }

      var _ref7 = acc[collectionId] || {
        yDomain: [Number.MAX_SAFE_INTEGER, Number.MIN_SAFE_INTEGER],
        ySubDomain: [Number.MAX_SAFE_INTEGER, Number.MIN_SAFE_INTEGER]
      },
          existingDomain = _ref7.yDomain,
          existingYSubDomain = _ref7.ySubDomain;

      return _extends({}, acc, (_extends7 = {}, _extends7[collectionId] = {
        yDomain: [Math.min(existingDomain[0], seriesDomain[0]), Math.max(existingDomain[1], seriesDomain[1])],
        ySubDomain: [Math.min(existingYSubDomain[0], seriesXSubDomain[0]), Math.max(existingYSubDomain[1], seriesXSubDomain[1])]
      }, _extends7));
    }, {});

    // Then we want to enrich the collection objects with their above-computed
    // domains.
    var collectionsById = {};
    var collectionsWithDomains = [];
    collections.forEach(function (c) {
      if (collectionDomains[c.id]) {
        var withDomain = _extends({}, c, collectionDomains[c.id]);
        collectionsWithDomains.push(withDomain);
        collectionsById[c.id] = withDomain;
      }
    });

    // Then take a final pass over all of the series and replace their
    // yDomain and ySubDomain arrays with the one from their collections (if
    // they're a member of a collection).
    var collectedSeries = seriesObjects.map(function (s) {
      if (s.collectionId !== undefined) {
        var copy = _extends({}, s);
        if (!collectionsById[copy.collectionId]) {
          // It's pointing to a collection that doesn't exist.
          copy.collectionId = undefined;
          return copy;
        }
        copy.yDomain = [].concat(collectionsById[copy.collectionId].yDomain);
        copy.ySubDomain = [].concat(collectionsById[copy.collectionId].ySubDomain);
        return copy;
      }
      return s;
    });

    var context = {
      series: collectedSeries,
      collections: collectionsWithDomains,
      timeDomain: timeDomain,
      // This is used to signal external changes vs internal changes
      externalTimeDomain: externalTimeDomain,
      timeSubDomain: timeSubDomain,
      // This is used to signal external changes vs internal changes
      externalTimeSubDomain: externalTimeSubDomain,
      yAxisWidth: yAxisWidth,
      timeSubDomainChanged: this.timeSubDomainChanged,
      limitTimeSubDomain: this.props.limitTimeSubDomain,
      onUpdateDomains: onUpdateDomains
    };
    return React.createElement(
      DataContext.Provider,
      { value: context },
      React.createElement(
        Scaler,
        null,
        children
      )
    );
  };

  return DataProvider;
}(Component), _class.getTimeSubDomain = function (timeDomain, timeSubDomain) {
  var limitTimeSubDomain = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (timeSubDomain) {
    return timeSubDomain;
  };

  if (!timeSubDomain) {
    return timeDomain;
  }
  var newTimeSubDomain = limitTimeSubDomain(timeSubDomain);
  var timeDomainLength = timeDomain[1] - timeDomain[0];
  var timeSubDomainLength = newTimeSubDomain[1] - newTimeSubDomain[0];
  if (timeDomainLength < timeSubDomainLength) {
    return timeDomain;
  }
  if (newTimeSubDomain[0] < timeDomain[0]) {
    return [timeDomain[0], timeDomain[0] + timeSubDomainLength];
  }
  if (newTimeSubDomain[1] > timeDomain[1]) {
    return [timeDomain[1] - timeSubDomainLength, timeDomain[1]];
  }
  return newTimeSubDomain;
}, _temp2);
export { DataProvider as default };


DataProvider.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A custom renderer for data points.
   *
   * @param {object} datapoint Current data point being rendered
   * @param {number} index Index of this current data point
   * @param {Array} datapoints All of the data points to be rendered
   * @param {object} metadata This object contains metadata useful for the
   * rendering process. This contains the following keys:
   *  - {@code x}: The x-position (in pixels) of the data point.
   *  - {@code x0}: The x-position (in pixels) for the data point's x0 value
   *  - {@code x1}: The x-position (in pixels) for the data point's x1 value
   *  - {@code y}: The y-position (in pixels) of the data point.
   *  - {@code y0}: The y-position (in pixels) for the data point's y0 value
   *  - {@code y1}: The y-position (in pixels) for the data point's y1 value
   *  - {@code color}: The color of this data point
   *  - {@code opacity}: The opacity of this data point
   *  - {@code opacityAccessor}: The opacity accessor for this data point
   *  - {@code pointWidth}: The width of this data point
   *  - {@code pointWidthAccessor}: The accessor for this data point's width
   *  - {@code strokeWidth}: The width of the stroke for this data point
   * @param {Array} elements This is an array of the items that Griff would
   * render for this data point. If custom rendering is not desired for this
   * data point, return this array as-is
   * @returns {(object|Array)} object(s) to render for this point.
   */
  drawPoints: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  drawLines: PropTypes.bool,
  timeDomain: PropTypes.arrayOf(PropTypes.number.isRequired),
  timeSubDomain: PropTypes.arrayOf(PropTypes.number.isRequired),
  xDomain: PropTypes.arrayOf(PropTypes.number.isRequired),
  xSubDomain: PropTypes.arrayOf(PropTypes.number.isRequired),
  updateInterval: PropTypes.number,
  timeAccessor: PropTypes.func,
  xAccessor: PropTypes.func,
  x0Accessor: PropTypes.func,
  x1Accessor: PropTypes.func,
  yAccessor: PropTypes.func,
  y0Accessor: PropTypes.func,
  y1Accessor: PropTypes.func,
  yAxisWidth: PropTypes.number,
  yDomain: PropTypes.arrayOf(PropTypes.number.isRequired),
  ySubDomain: PropTypes.arrayOf(PropTypes.number.isRequired),
  pointsPerSeries: PropTypes.number,
  children: PropTypes.node.isRequired,
  defaultLoader: PropTypes.func,
  series: seriesPropType.isRequired,
  collections: GriffPropTypes.collections,
  // xSubDomain => void
  onTimeSubDomainChanged: PropTypes.func,
  // newSubDomainsPerItem => void
  onUpdateDomains: PropTypes.func,
  opacity: PropTypes.number,
  /** (datapoint, index, datapoints) => number */
  opacityAccessor: PropTypes.func,

  pointWidth: PropTypes.number,
  /** (datapoint, index, datapoints) => number */
  pointWidthAccessor: PropTypes.func,
  strokeWidth: PropTypes.number,
  // if set to true and an updateInterval is provided, xSubDomain
  // will be increased at every interval (similarly to xDomain)
  isTimeSubDomainSticky: PropTypes.bool,
  // timeSubDomain => timeSubDomain
  // function to allow limitation of the value of timeSubDomain
  limitTimeSubDomain: PropTypes.func,
  // loaderConfig => void
  // called whenever data is fetched by the loader
  onFetchData: PropTypes.func
} : {};

DataProvider.defaultProps = {
  collections: [],
  defaultLoader: null,
  drawPoints: null,
  drawLines: undefined,
  onTimeSubDomainChanged: null,
  onUpdateDomains: null,
  opacity: 1.0,
  opacityAccessor: null,
  pointsPerSeries: 250,
  pointWidth: null,
  pointWidthAccessor: null,
  strokeWidth: null,
  timeDomain: null,
  timeSubDomain: null,
  xDomain: null,
  xSubDomain: null,
  updateInterval: 0,
  timeAccessor: function timeAccessor(d) {
    return d.timestamp;
  },
  x0Accessor: null,
  x1Accessor: null,
  xAccessor: function xAccessor(d) {
    return d.timestamp;
  },
  y0Accessor: null,
  y1Accessor: null,
  yAccessor: function yAccessor(d) {
    return d.value;
  },
  yAxisWidth: 50,
  yDomain: null,
  ySubDomain: null,
  isTimeSubDomainSticky: false,
  limitTimeSubDomain: function limitTimeSubDomain(xSubDomain) {
    return xSubDomain;
  },
  onFetchData: function onFetchData() {}
};